import { CalculatorPage } from '@/cms/definitions/content-types';
import BuyInsuranceComponent from '@/views/calculators/BuyInsuranceComponent.vue';
import { PropType } from 'vue';
import { Options, Vue } from 'vue-class-component';

@Options({
	name: 'CalculatorPageComponent',
	components: {
		BuyInsuranceComponent,
	},
	props: {
		model: Object as PropType<CalculatorPage>,
	},
})
export default class CalculatorPageComponent extends Vue {
	model: CalculatorPage;
}
